import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { SaleOrderItemsDto } from './sale-order-items.dto';
import { SaleOrderDto } from './sale-order.dto';


export class SaleOrderItemsResponseModel extends GlobalResponseObject{
    data?: SaleOrderItemsDto;

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status:boolean, intlCode:number, internalMessage:string, data?: SaleOrderItemsDto){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

